import React from 'react';
import { Navigate } from 'react-router-dom';
import SpinnerCargando from '../componentes/util/SpinnerCargando';
import { useContextoSesion } from './ContextoSesion';

const RutaProtegida = ({ children, permisoRequerido }) => {
  const { token, usuario, sesionActiva, cargando, tienePermiso } = useContextoSesion();

 if (cargando) {
  return <SpinnerCargando />;
}


  if (!sesionActiva || !token) {
    return <Navigate to="/" />;
  }

  try {
    // Verificar que el token no haya expirado (client-side check)
    const ahora = Date.now() / 1000;
    if (usuario?.exp && usuario.exp < ahora) {
      return <Navigate to="/" />;
    }

    // Validación de permisos usando tienePermiso del contexto
    if (permisoRequerido && !tienePermiso(permisoRequerido)) {
      return (
        <div className="min-h-screen bg-gray-100 flex items-center justify-center">
          <div className="bg-white rounded-2xl shadow-lg border border-gray-200 p-10 max-w-md text-center">
            <div className="bg-red-100 rounded-full p-5 w-20 h-20 mx-auto mb-6 flex items-center justify-center">
              <svg className="w-10 h-10 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m0 0v2m0-2h2m-2 0H10m5-7a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </div>
            <h2 className="text-xl font-bold text-gray-800 mb-3">Acceso denegado</h2>
            <p className="text-gray-600 mb-6">
              No tienes permiso para acceder a esta sección. Contacta al administrador si necesitas acceso.
            </p>
            <a
              href="/Dashboard"
              className="inline-block px-6 py-3 bg-blue-600 text-white rounded-xl font-semibold hover:bg-blue-700 transition-all duration-200 shadow-md"
            >
              Volver al Dashboard
            </a>
          </div>
        </div>
      );
    }

    return children;

  } catch (error) {
    console.log("Error al verificar permisos:", error);
    return <Navigate to="/" />;
  }
};

export default RutaProtegida;
